import React from 'react'
import PropTypes from 'prop-types'
import ReactImageGallery from 'react-image-gallery'
import Text from '@components/Text'
import Button from '@components/Button'
import { BUTTON_SIZE, COLORS } from '@helpers/constants'
import Icon from '@components/Icon'

const RightNav = ({onClick, disabled}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="mr-4 rounded-full transition-all cursor-pointer absolute z-[4] outline-none bg-black right-0 top-1/2 transform translate-y-[-50%] w-[76px] h-[76px]"
        disabled={disabled}
        onClick={onClick}
        aria-label="Previous Slide"
      >
        <div className="flex justify-center w-full">
          <Icon icon={'ChevronRightBig'} color={disabled ? COLORS.LIGHT_DARK_GREY.TEXT : COLORS.WHITE.TEXT} />
        </div>
      </button>
    </div>
  )
}

RightNav.displayName = 'RightNav'

const MemoizedRightNav = React.memo(RightNav)

export default MemoizedRightNav
